var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.5V12h2.5l7.372-7.372-2.5-2.5L0 9.5Zm11.805-6.805c.26-.26.26-.68 0-.94l-1.56-1.56a.664.664 0 0 0-.94 0l-1.22 1.22 2.5 2.5 1.22-1.22Z",
    fill: "currentColor"
  })));
};
export { SvgEdit as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgOS41MDAzNVYxMkgyLjQ5OTY1TDkuODcxOTYgNC42Mjc2OUw3LjM3MjMxIDIuMTI4MDRMMCA5LjUwMDM1Wk0xMS44MDUgMi42OTQ2M0MxMi4wNjUgMi40MzQ2NiAxMi4wNjUgMi4wMTQ3MiAxMS44MDUgMS43NTQ3NkwxMC4yNDUyIDAuMTk0OTczQzkuOTg1MjggLTAuMDY0OTkxIDkuNTY1MzQgLTAuMDY0OTkxIDkuMzA1MzcgMC4xOTQ5NzNMOC4wODU1NCAxLjQxNDhMMTAuNTg1MiAzLjkxNDQ2TDExLjgwNSAyLjY5NDYzWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";